var _rect, _g, _path, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueWood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 114,
    viewBox: "0 0 1440 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 114,
    fill: "#E7EDF4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2694_359)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2694_359)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45 180V0H70V180H45ZM67 76H57.5H48C48 71.4436 51.8161 64 57.5 64C63.1839 64 67 71.4436 67 76ZM48.0001 78L57.5001 110L67.0001 78H48.0001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 111.5,
    y1: 180,
    x2: 111.5,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155.5,
    y1: 180,
    x2: 155.5,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202 180V0H227V180H202ZM224 76H214.5H205C205 71.4436 208.816 64 214.5 64C220.184 64 224 71.4436 224 76ZM205 78L214.5 110L224 78H205Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 268.5,
    y1: 180,
    x2: 268.5,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 312.5,
    y1: 180,
    x2: 312.5,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M359 180V0H384V180H359ZM381 76H371.5H362C362 71.4436 365.816 64 371.5 64C377.184 64 381 71.4436 381 76ZM362 78L371.5 110L381 78H362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 425.5,
    y1: 180,
    x2: 425.5,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 469.5,
    y1: 180,
    x2: 469.5,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M516 180V0H541V180H516ZM538 76H528.5H519C519 71.4436 522.816 64 528.5 64C534.184 64 538 71.4436 538 76ZM519 78L528.5 110L538 78H519Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 582.5,
    y1: 180,
    x2: 582.5,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 626.5,
    y1: 180,
    x2: 626.5,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M673 180V0H698V180H673ZM695 76H685.5H676C676 71.4436 679.816 64 685.5 64C691.184 64 695 71.4436 695 76ZM676 78L685.5 110L695 78H676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M742 180V0H767V180H742ZM764 76H754.5H745C745 71.4436 748.816 64 754.5 64C760.184 64 764 71.4436 764 76ZM745 78L754.5 110L764 78H745Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 808.5,
    y1: 180,
    x2: 808.5,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 852.5,
    y1: 180,
    x2: 852.5,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M899 180V0H924V180H899ZM921 76H911.5H902C902 71.4436 905.816 64 911.5 64C917.184 64 921 71.4436 921 76ZM902 78L911.5 110L921 78H902Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 965.5,
    y1: 180,
    x2: 965.5,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1009.5,
    y1: 180,
    x2: 1009.5,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1056 180V0H1081V180H1056ZM1078 76H1068.5H1059C1059 71.4436 1062.82 64 1068.5 64C1074.18 64 1078 71.4436 1078 76ZM1059 78L1068.5 110L1078 78H1059Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1122.5,
    y1: 180,
    x2: 1122.5,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1166.5,
    y1: 180,
    x2: 1166.5,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1213 180V0H1238V180H1213ZM1235 76H1225.5H1216C1216 71.4436 1219.82 64 1225.5 64C1231.18 64 1235 71.4436 1235 76ZM1216 78L1225.5 110L1235 78H1216Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1279.5,
    y1: 180,
    x2: 1279.5,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1323.5,
    y1: 180,
    x2: 1323.5,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1370 180V0H1395V180H1370ZM1392 76H1382.5H1373C1373 71.4436 1376.82 64 1382.5 64C1388.18 64 1392 71.4436 1392 76ZM1373 78L1382.5 110L1392 78H1373Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 1436,
    height: 24,
    stroke: "white",
    strokeWidth: 4
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M463.522 52.1484H456.989C456.87 51.3033 456.626 50.5526 456.258 49.8963C455.89 49.2301 455.418 48.6634 454.841 48.196C454.265 47.7287 453.599 47.3707 452.843 47.1222C452.097 46.8736 451.287 46.7493 450.412 46.7493C448.831 46.7493 447.454 47.142 446.28 47.9276C445.107 48.7031 444.197 49.8366 443.551 51.3281C442.905 52.8097 442.581 54.6094 442.581 56.7273C442.581 58.9048 442.905 60.7344 443.551 62.2159C444.207 63.6974 445.122 64.8161 446.295 65.5717C447.469 66.3274 448.826 66.7053 450.367 66.7053C451.232 66.7053 452.032 66.5909 452.768 66.3622C453.514 66.1335 454.175 65.8004 454.752 65.3629C455.329 64.9155 455.806 64.3736 456.184 63.7372C456.572 63.1009 456.84 62.375 456.989 61.5597L463.522 61.5895C463.353 62.9915 462.93 64.3438 462.254 65.6463C461.588 66.9389 460.688 68.0973 459.555 69.1214C458.431 70.1357 457.089 70.9411 455.528 71.5376C453.976 72.1243 452.221 72.4176 450.263 72.4176C447.538 72.4176 445.102 71.8011 442.954 70.5682C440.817 69.3352 439.126 67.5504 437.883 65.2138C436.65 62.8771 436.034 60.0483 436.034 56.7273C436.034 53.3963 436.66 50.5625 437.913 48.2259C439.166 45.8892 440.866 44.1094 443.014 42.8864C445.162 41.6534 447.578 41.0369 450.263 41.0369C452.032 41.0369 453.673 41.2855 455.184 41.7827C456.706 42.2798 458.053 43.0057 459.226 43.9602C460.4 44.9048 461.354 46.0632 462.09 47.4354C462.836 48.8075 463.313 50.3786 463.522 52.1484ZM496.222 56.7273C496.222 60.0582 495.591 62.892 494.328 65.2287C493.075 67.5653 491.365 69.3501 489.198 70.5831C487.04 71.8061 484.614 72.4176 481.919 72.4176C479.205 72.4176 476.769 71.8011 474.611 70.5682C472.453 69.3352 470.748 67.5504 469.495 65.2138C468.242 62.8771 467.616 60.0483 467.616 56.7273C467.616 53.3963 468.242 50.5625 469.495 48.2259C470.748 45.8892 472.453 44.1094 474.611 42.8864C476.769 41.6534 479.205 41.0369 481.919 41.0369C484.614 41.0369 487.04 41.6534 489.198 42.8864C491.365 44.1094 493.075 45.8892 494.328 48.2259C495.591 50.5625 496.222 53.3963 496.222 56.7273ZM489.675 56.7273C489.675 54.5696 489.352 52.75 488.705 51.2685C488.069 49.7869 487.169 48.6634 486.006 47.8977C484.843 47.1321 483.48 46.7493 481.919 46.7493C480.358 46.7493 478.996 47.1321 477.833 47.8977C476.669 48.6634 475.764 49.7869 475.118 51.2685C474.482 52.75 474.164 54.5696 474.164 56.7273C474.164 58.8849 474.482 60.7045 475.118 62.1861C475.764 63.6676 476.669 64.7912 477.833 65.5568C478.996 66.3224 480.358 66.7053 481.919 66.7053C483.48 66.7053 484.843 66.3224 486.006 65.5568C487.169 64.7912 488.069 63.6676 488.705 62.1861C489.352 60.7045 489.675 58.8849 489.675 56.7273ZM501.006 41.4545H508.971L517.383 61.9773H517.741L526.153 41.4545H534.117V72H527.853V52.1186H527.599L519.695 71.8509H515.429L507.524 52.044H507.271V72H501.006V41.4545ZM539.438 41.4545H547.403L555.814 61.9773H556.172L564.584 41.4545H572.549V72H566.285V52.1186H566.031L558.126 71.8509H553.861L545.956 52.044H545.702V72H539.438V41.4545ZM584.328 41.4545V72H577.87V41.4545H584.328ZM588.478 46.7791V41.4545H613.564V46.7791H604.213V72H597.829V46.7791H588.478ZM617.696 41.4545H625.66L634.072 61.9773H634.43L642.842 41.4545H650.807V72H644.542V52.1186H644.289L636.384 71.8509H632.118L624.214 52.044H623.96V72H617.696V41.4545ZM656.127 72V41.4545H676.71V46.7791H662.586V54.0575H675.651V59.3821H662.586V66.6754H676.77V72H656.127ZM707.393 41.4545V72H701.815L688.526 52.7749H688.302V72H681.844V41.4545H687.512L700.697 60.6648H700.965V41.4545H707.393ZM711.566 46.7791V41.4545H736.652V46.7791H727.301V72H720.917V46.7791H711.566ZM749.341 46.7791V41.4545H774.428V46.7791H765.076V72H758.693V46.7791H749.341ZM805.234 56.7273C805.234 60.0582 804.603 62.892 803.34 65.2287C802.087 67.5653 800.377 69.3501 798.209 70.5831C796.052 71.8061 793.626 72.4176 790.931 72.4176C788.216 72.4176 785.78 71.8011 783.623 70.5682C781.465 69.3352 779.76 67.5504 778.507 65.2138C777.254 62.8771 776.628 60.0483 776.628 56.7273C776.628 53.3963 777.254 50.5625 778.507 48.2259C779.76 45.8892 781.465 44.1094 783.623 42.8864C785.78 41.6534 788.216 41.0369 790.931 41.0369C793.626 41.0369 796.052 41.6534 798.209 42.8864C800.377 44.1094 802.087 45.8892 803.34 48.2259C804.603 50.5625 805.234 53.3963 805.234 56.7273ZM798.687 56.7273C798.687 54.5696 798.363 52.75 797.717 51.2685C797.081 49.7869 796.181 48.6634 795.018 47.8977C793.854 47.1321 792.492 46.7493 790.931 46.7493C789.37 46.7493 788.008 47.1321 786.844 47.8977C785.681 48.6634 784.776 49.7869 784.13 51.2685C783.493 52.75 783.175 54.5696 783.175 56.7273C783.175 58.8849 783.493 60.7045 784.13 62.1861C784.776 63.6676 785.681 64.7912 786.844 65.5568C788.008 66.3224 789.37 66.7053 790.931 66.7053C792.492 66.7053 793.854 66.3224 795.018 65.5568C796.181 64.7912 797.081 63.6676 797.717 62.1861C798.363 60.7045 798.687 58.8849 798.687 56.7273ZM831.268 61.3807H836.757L839.516 64.9304L842.23 68.0923L847.346 74.5057H841.32L837.801 70.1804L835.996 67.6151L831.268 61.3807ZM847.808 56.7273C847.808 60.0582 847.177 62.892 845.914 65.2287C844.661 67.5653 842.951 69.3501 840.784 70.5831C838.626 71.8061 836.2 72.4176 833.505 72.4176C830.791 72.4176 828.355 71.8011 826.197 70.5682C824.039 69.3352 822.334 67.5504 821.081 65.2138C819.828 62.8771 819.202 60.0483 819.202 56.7273C819.202 53.3963 819.828 50.5625 821.081 48.2259C822.334 45.8892 824.039 44.1094 826.197 42.8864C828.355 41.6534 830.791 41.0369 833.505 41.0369C836.2 41.0369 838.626 41.6534 840.784 42.8864C842.951 44.1094 844.661 45.8892 845.914 48.2259C847.177 50.5625 847.808 53.3963 847.808 56.7273ZM841.261 56.7273C841.261 54.5696 840.938 52.75 840.291 51.2685C839.655 49.7869 838.755 48.6634 837.592 47.8977C836.428 47.1321 835.066 46.7493 833.505 46.7493C831.944 46.7493 830.582 47.1321 829.419 47.8977C828.255 48.6634 827.35 49.7869 826.704 51.2685C826.068 52.75 825.749 54.5696 825.749 56.7273C825.749 58.8849 826.068 60.7045 826.704 62.1861C827.35 63.6676 828.255 64.7912 829.419 65.5568C830.582 66.3224 831.944 66.7053 833.505 66.7053C835.066 66.7053 836.428 66.3224 837.592 65.5568C838.755 64.7912 839.655 63.6676 840.291 62.1861C840.938 60.7045 841.261 58.8849 841.261 56.7273ZM871.46 41.4545H877.918V61.2912C877.918 63.5185 877.386 65.4673 876.322 67.1378C875.268 68.8082 873.791 70.1108 871.892 71.0455C869.993 71.9702 867.781 72.4325 865.255 72.4325C862.719 72.4325 860.502 71.9702 858.603 71.0455C856.704 70.1108 855.227 68.8082 854.173 67.1378C853.119 65.4673 852.592 63.5185 852.592 61.2912V41.4545H859.05V60.7393C859.05 61.9027 859.304 62.9368 859.811 63.8416C860.328 64.7464 861.054 65.4574 861.989 65.9744C862.923 66.4915 864.012 66.75 865.255 66.75C866.508 66.75 867.597 66.4915 868.521 65.9744C869.456 65.4574 870.177 64.7464 870.684 63.8416C871.201 62.9368 871.46 61.9027 871.46 60.7393V41.4545ZM888.496 72H881.575L892.12 41.4545H900.443L910.972 72H904.052L896.401 48.4347H896.162L888.496 72ZM888.063 59.9936H904.41V65.0348H888.063V59.9936ZM914.649 72V41.4545H921.107V66.6754H934.202V72H914.649ZM944.937 41.4545V72H938.479V41.4545H944.937ZM949.087 46.7791V41.4545H974.174V46.7791H964.822V72H958.439V46.7791H949.087ZM976.515 41.4545H983.749L990.714 54.6094H991.013L997.978 41.4545H1005.21L994.07 61.2017V72H987.657V61.2017L976.515 41.4545Z",
    fill: "#A7A9AC"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2694_359)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_2694_359)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45 266V86H70V266H45ZM67 162H57.5H48C48 157.444 51.8161 150 57.5 150C63.1839 150 67 157.444 67 162ZM48.0001 164L57.5001 196L67.0001 164H48.0001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 111.5,
    y1: 266,
    x2: 111.5,
    y2: 86,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155.5,
    y1: 266,
    x2: 155.5,
    y2: 86,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202 266V86H227V266H202ZM224 162H214.5H205C205 157.444 208.816 150 214.5 150C220.184 150 224 157.444 224 162ZM205 164L214.5 196L224 164H205Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 268.5,
    y1: 266,
    x2: 268.5,
    y2: 86,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 312.5,
    y1: 266,
    x2: 312.5,
    y2: 86,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M359 266V86H384V266H359ZM381 162H371.5H362C362 157.444 365.816 150 371.5 150C377.184 150 381 157.444 381 162ZM362 164L371.5 196L381 164H362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 425.5,
    y1: 266,
    x2: 425.5,
    y2: 86,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 469.5,
    y1: 266,
    x2: 469.5,
    y2: 86,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M516 266V86H541V266H516ZM538 162H528.5H519C519 157.444 522.816 150 528.5 150C534.184 150 538 157.444 538 162ZM519 164L528.5 196L538 164H519Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 582.5,
    y1: 266,
    x2: 582.5,
    y2: 86,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 626.5,
    y1: 266,
    x2: 626.5,
    y2: 86,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M673 266V86H698V266H673ZM695 162H685.5H676C676 157.444 679.816 150 685.5 150C691.184 150 695 157.444 695 162ZM676 164L685.5 196L695 164H676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M742 266V86H767V266H742ZM764 162H754.5H745C745 157.444 748.816 150 754.5 150C760.184 150 764 157.444 764 162ZM745 164L754.5 196L764 164H745Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 808.5,
    y1: 266,
    x2: 808.5,
    y2: 86,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 852.5,
    y1: 266,
    x2: 852.5,
    y2: 86,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M899 266V86H924V266H899ZM921 162H911.5H902C902 157.444 905.816 150 911.5 150C917.184 150 921 157.444 921 162ZM902 164L911.5 196L921 164H902Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 965.5,
    y1: 266,
    x2: 965.5,
    y2: 86,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1009.5,
    y1: 266,
    x2: 1009.5,
    y2: 86,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1056 266V86H1081V266H1056ZM1078 162H1068.5H1059C1059 157.444 1062.82 150 1068.5 150C1074.18 150 1078 157.444 1078 162ZM1059 164L1068.5 196L1078 164H1059Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1122.5,
    y1: 266,
    x2: 1122.5,
    y2: 86,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1166.5,
    y1: 266,
    x2: 1166.5,
    y2: 86,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1213 266V86H1238V266H1213ZM1235 162H1225.5H1216C1216 157.444 1219.82 150 1225.5 150C1231.18 150 1235 157.444 1235 162ZM1216 164L1225.5 196L1235 164H1216Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1279.5,
    y1: 266,
    x2: 1279.5,
    y2: 86,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1323.5,
    y1: 266,
    x2: 1323.5,
    y2: 86,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1370 266V86H1395V266H1370ZM1392 162H1382.5H1373C1373 157.444 1376.82 150 1382.5 150C1388.18 150 1392 157.444 1392 162ZM1373 164L1382.5 196L1392 164H1373Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 88,
    width: 1436,
    height: 24,
    stroke: "white",
    strokeWidth: 4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2694_359"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 28,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2694_359"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 28,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2694_359"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 28,
    fill: "white",
    transform: "translate(0 86)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_2694_359"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 86,
    width: 1440,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueWood);
export default __webpack_public_path__ + "static/media/blueWood.d18ab5e4f61690e04abcb34b2ab5d407.svg";
export { ForwardRef as ReactComponent };